// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ZeroResults__container___3rjBB{display:flex;align-items:center;flex-direction:column;margin-top:50px}.ZeroResults__title___1ukrK{font-weight:500;font-size:22px;padding-bottom:10px}\n", ""]);
// Exports
exports.locals = {
	"container": "ZeroResults__container___3rjBB",
	"title": "ZeroResults__title___1ukrK"
};
module.exports = exports;
